import * as React from 'react'
import BaseIcon from 'react-icon-base'
import { IIconProps } from './interface'
import { EColors } from 'app/constants/colors'

const Share = (props: IIconProps) => (
  <BaseIcon width="16" height="19" viewBox="0 1 16 19" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g fill="none" fillRule="evenodd">
      <path
        d="M11.626 7.508h1.401c.776 0 1.405.629 1.405 1.405v6.838a2 2 0 0 1-2 2H3.667a2 2 0 0 1-2-2V9.537a2 2 0 0 1 2-2h.78M8.05 11.63V3.352"
        stroke={EColors.BLUE}
        strokeWidth="1.5"
      />
      <path fill={EColors.BLUE} d="M4.565 4.154 8.05.71l3.485 3.444z" />
    </g>
  </BaseIcon>
)

export default Share
